import { pstyle } from "../lib/pstyle.js";
import Hoverable from "../lib/Hoverable.jsx";

export default function Compare({ v }) {
  return (
    <div style={pstyle("padding:48px 44px 80px; max-width:1080px; margin:0 auto; display:flex; flex-direction:column; gap:26px;")}>
      <div style={pstyle("display:flex; flex-direction:column; gap:10px;")}>
        <h1 style={pstyle("margin:0; font-size:32px; font-weight:600; letter-spacing:-0.025em;")}>Fiches comparatives</h1>
        <p style={pstyle("margin:0; font-size:15px; color:oklch(0.5 0.015 60);")}>Même grille de critères pour chaque duel : décider vite, justifier ensuite.</p>
      </div>
      <div style={pstyle("display:flex; gap:8px; flex-wrap:wrap;")}>
        {v.compareTabs.map((t, i) => (
          <button key={i} type="button" onClick={t.onClick} style={pstyle("font:inherit; font-size:13px; border-radius:999px; padding:6px 14px; cursor:pointer;", { border: "1px solid " + t.border, color: t.color, background: t.bg })}>{t.label}</button>
        ))}
      </div>
      <div style={pstyle("border:1px solid oklch(0.93 0.008 85); border-radius:8px; overflow:hidden;")}>
        <div style={pstyle("display:grid; grid-template-columns:220px 1fr 1fr; background:oklch(0.985 0.005 85); border-bottom:1px solid oklch(0.93 0.008 85);")}>
          <span style={pstyle("padding:14px; font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60);")}>Critère</span>
          <span style={pstyle("padding:14px; font-size:15px; font-weight:600; color:oklch(0.24 0.012 60);")}>{v.compareA}</span>
          <span style={pstyle("padding:14px; font-size:15px; font-weight:600; color:oklch(0.24 0.012 60);")}>{v.compareB}</span>
        </div>
        {v.compareRows.map((r, i) => (
          <div key={i} style={pstyle("display:grid; grid-template-columns:220px 1fr 1fr; border-bottom:1px solid oklch(0.96 0.006 85);")}>
            <span style={pstyle("padding:13px 14px; font-size:13.5px; color:oklch(0.5 0.015 60);")}>{r.crit}</span>
            <span style={pstyle("padding:13px 14px; font-size:14px; line-height:1.55; border-left:1px solid oklch(0.97 0.006 85); text-wrap:pretty;", { color: r.aColor })}>{r.a}</span>
            <span style={pstyle("padding:13px 14px; font-size:14px; line-height:1.55; border-left:1px solid oklch(0.97 0.006 85); text-wrap:pretty;", { color: r.bColor })}>{r.b}</span>
          </div>
        ))}
      </div>
      <div style={pstyle("display:flex; gap:24px; align-items:flex-start;")}>
        <div style={pstyle("flex:1; border-left:2px solid oklch(0.46 0.075 55); padding:2px 0 2px 16px; font-size:14.5px; line-height:1.7; color:oklch(0.32 0.015 60); text-wrap:pretty;")}>{v.compareVerdict}</div>
        <div style={pstyle("width:260px; display:flex; flex-direction:column; gap:8px;")}>
          <span style={pstyle("font-size:12px; font-weight:600; letter-spacing:0.06em; text-transform:uppercase; color:oklch(0.55 0.015 60);")}>Fiches liées</span>
          {v.compareLinks.map((l, i) => (
            <Hoverable key={i} as="span" onClick={l.onClick} style={pstyle("font-size:13.5px; color:oklch(0.4 0.015 60); cursor:pointer;")} hoverStyle={{ color: "oklch(0.46 0.075 55)" }}>{l.title}</Hoverable>
          ))}
        </div>
      </div>
    </div>
  );
}
